import React from "react";

type Props = {
  hasNewMessage: boolean;
  hasNewOrder: boolean;
  itemKey: string;
};
const NewSidebarAlertComp: React.FC<Props> = ({
  hasNewMessage,
  hasNewOrder,
  itemKey,
}) => {
  const showElement =
    (itemKey === "chat" && hasNewMessage) ||
    (itemKey === "new-orders" && hasNewOrder);

  if (!showElement) return null;
  return showElement && <div className="w-2 h-2 bg-red-500 rounded-full" />;
};

export default NewSidebarAlertComp;
